import React from 'react';
import ReactDOM from 'react-dom';


import WhatsOnListing from './WhatsOnListing';
import WhatsOnListingWrap from './WhatsOnListingWrap';
import CityIsAGym from './CityIsAGym'
import RoutesMap from './RoutesMap.jsx'

const WhatsOnListingElem = document.getElementById("WhatsOnListing")
const FindYour30ListingElem = document.getElementById("FindYour30Listing")
const DealsListingElem = document.getElementById("DealsListing")
const CityIsAGymElem = document.getElementById("CityIsAGym")
const PressReleaseElem = document.getElementById("PressRelease")
const RoutesMapElem = document.getElementById("RoutesMap")


if (WhatsOnListingElem) {
  ReactDOM.render(<WhatsOnListingWrap/>, WhatsOnListingElem);
}

if (FindYour30ListingElem) {
  ReactDOM.render(<WhatsOnListing articleListing={true} />, FindYour30ListingElem);
}
if (DealsListingElem) {
  ReactDOM.render(<WhatsOnListing dealsListing={true} />, DealsListingElem);
}

if (CityIsAGymElem) {
  ReactDOM.render(<CityIsAGym />, CityIsAGymElem);
}

if (PressReleaseElem) {
  ReactDOM.render(<WhatsOnListing pressReleaseListing={true} />, PressReleaseElem);
}
if (RoutesMapElem) {
  ReactDOM.render(<RoutesMap />, RoutesMapElem);
}

